/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../../../../_metronic/_helpers";

export const ActionsColumnFormatter = (
    cellContent,
    row,
    rowIndex,
    { openEditPeriodeKurbanPage, allowEdit, handleShow }
) => (
    <>

        {allowEdit &&
            <OverlayTrigger
                overlay={<Tooltip id="products-edit-tooltip">Edit Periode Kurban</Tooltip>}
            >
                <a
                    onClick={() => openEditPeriodeKurbanPage(row.uuid)}

                >{row.id}

                    <button className="btn btn-primary btn-sm mb-1">Edit</button>
                </a>
            </OverlayTrigger>}

        {allowEdit && !row.is_active && <OverlayTrigger
            overlay={<Tooltip id="products-edit-tooltip">{row.is_active ? "Non-aktifkan" : "Aktifkan"}</Tooltip>}
        >
            <a
                onClick={() => handleShow(row)}
            >{row.id}
                <button className={`btn ${row.is_active ? 'btn-warning' : 'btn-success'} btn-sm`}>{row.is_active ? "Non-aktifkan" : "Aktifkan"}</button>
            </a>
        </OverlayTrigger>}



        <> </>
        {/*<OverlayTrigger*/}
        {/*    overlay={<Tooltip id="products-delete-tooltip">Delete donatur</Tooltip>}*/}
        {/*>*/}
        {/*    <a*/}
        {/*        className="btn btn-icon btn-light btn-hover-danger btn-sm"*/}
        {/*        onClick={() => console.log('deleted id : ', row.uuid)}*/}
        {/*    >*/}
        {/*<span className="svg-icon svg-icon-md svg-icon-danger">*/}
        {/*  <SVG src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")}/>*/}
        {/*</span>*/}
        {/*    </a>*/}
        {/*</OverlayTrigger>*/}
    </>
);
